import { Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-chi-siamo-fr',
  templateUrl: './fr.component.html',
  styleUrl: './fr.component.scss'
})
export class ChiSiamoFrComponent {
  constructor(protected deviceService: DeviceDetectorService) { }

  get isMobile(){
    return this.deviceService.isMobile() ;
  }

  get isDesktop(){
    return this.deviceService.isDesktop() ;
  }
}